import TariffMergeRouterView from './components/TariffMergeRouterView'
import TariffMerge from './components/TariffMerge'

import store from '../../store'
import event from '../../event'
import { handleNext } from '../helpers/RouteHelpers'

export default [
  {
    path: 'tariff-merge',
    component: TariffMergeRouterView,
    children: [
      {
        path: '',
        component: TariffMerge,
        name: 'Merge Tariffs',
        meta: {description: 'Quickly Merge Tariffs'},
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const init = store.dispatch('systemOption/initialise')
          handleNext([init], next)
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/tariffmerge/routes.js